import dayjs from 'dayjs'

/** Same format as start/end date pickers in budget & dates settings. */
export const ADGROUP_FLIGHT_DATE_FORMAT = 'DD/MM/YYYY'

const parseActivityFeedDateValue = (value: string): dayjs.Dayjs => {
  const trimmed = value.trim()
  const dateOnlyMatch = trimmed.match(/^(\d{4}-\d{2}-\d{2})/)
  if (dateOnlyMatch) return dayjs(dateOnlyMatch[1])

  if (/^\d{2}\/\d{2}\/\d{4}$/.test(trimmed)) {
    const [day, month, year] = trimmed.split('/')
    return dayjs(`${year}-${month}-${day}`)
  }

  return dayjs(trimmed)
}

/** Formats activity-feed raw start/end values like the ad group date inputs. */
export const formatAdGroupFlightDateForDisplay = (value: string | null | undefined, fallback = ''): string => {
  if (value == null || value === '') return fallback

  const parsed = parseActivityFeedDateValue(value)
  if (!parsed.isValid()) return fallback || value

  return parsed.format(ADGROUP_FLIGHT_DATE_FORMAT)
}
